import { useSubjectsById } from 'shared/api/subjects'
import React, { useMemo } from 'react'
import { ItemSelect } from './ItemSelect'
import { keyTest } from 'shared/utils'
import { Box } from '@mui/material'

export function SubjectDisplay<T extends { id: number }>({
  item,
  columnData: { key: subjectKey },
}: {
  item: T
  columnData: { key: string }
}) {
  const subjectsById = useSubjectsById()
  if (!keyTest(item, subjectKey)) return <Box />
  const subjectId = Number(item[subjectKey])
  const subject = subjectsById?.[subjectId]
  if (!subject) return <Box />
  return <Box>{`${subjectId}: ${subject.subject_name}`}</Box>
}

export function SubjectEdit<T extends { id: number }>({
  item,
  columnData: { key: subjectKey, setKey },
}: {
  item: T
  columnData: { key: string; setKey?: string }
}) {
  const hasKey = keyTest(item, subjectKey)
  const subjectId = hasKey ? Number(item[subjectKey]) : undefined
  return (
    <SubjectSelect initialSubjectId={subjectId} setKey={setKey ?? subjectKey} />
  )
}

function SubjectSelect({
  initialSubjectId,
  setKey,
}: {
  initialSubjectId?: number
  setKey: string
}) {
  const subjectsById = useSubjectsById()
  const subject =
    initialSubjectId &&
    subjectsById &&
    initialSubjectId in subjectsById &&
    subjectsById[initialSubjectId]

  const subjects = useMemo(() => {
    return Object.values(subjectsById ?? {})
  }, [subjectsById])

  return (
    <ItemSelect
      setKey={setKey}
      initialItem={subject || undefined}
      items={subjects}
      itemDisplay={(item) => item?.subject_name ?? ''}
    />
  )
}
